import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../services/api';

export function useCiClassesQuery(
  tenantId: string | undefined,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['ci-classes', tenantId],
    queryFn: () => apiClient.getCiClasses(tenantId!),
    enabled: !!tenantId && options?.enabled !== false,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
